<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline" @keyup.enter.native="searchQuery">
      <a-row :gutter="24">
        <a-col :md="6" :sm="8">
          <a-form-item :label="$t(I18N_KEY + 'userName')">
            <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'userName')" v-model="queryParam.userName"
              :allowClear='allowClear'></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item :label="$t(I18N_KEY + 'seatMobile')">
            <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'seatMobile')" v-model="queryParam.mobile"
              :allowClear='allowClear'></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item :label="$t(I18N_KEY + 'userGroup')">
            <a-select v-model="queryParam.groupId" :placeholder="$t('select')" style="width: 100%"
              :allowClear='allowClear'>
              <a-select-option value="">{{ $t(I18N_KEY + 'all') }}</a-select-option>
              <a-select-option value="0">{{ $t(I18N_KEY + 'noGroup') }}</a-select-option>
              <a-select-option v-for='item in userGroups' :key='item.value'>
                {{ item[fieldName] }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8">
          <a-form-item :label="$t(I18N_KEY + 'userGroupStatus')">
            <a-select v-model="queryParam.status" :placeholder="$t('select')" style="width: 100%"
              :allowClear='allowClear'>
              <a-select-option value="">{{ $t(I18N_KEY + 'all') }}</a-select-option>
              <a-select-option v-for='item in statuses' :key='item'>
                {{ $t(I18N_KEY + 'seatStatus_' + item) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="table-operator" style="margin-top: 5px">
      <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('add') }}</a-button>
    </div>
    <a-table ref="table" size="middle" rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="false"
      :loading="loading" bordered>
      <template #status="text, record, index">
        <a-badge :status="text == '0' ? 'success' : 'default'" />
        {{ $t(I18N_KEY + 'seatStatus_' + text) }}
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('edit') }}</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            {{ $t('more') }} <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <!--              <a-popconfirm :title="$t('confirmDelete')" @confirm="() => deleteCurrent(record)">-->
              <!--                <a>{{ $t('delete') }}</a>-->
              <!--              </a-popconfirm>-->
              <a-popconfirm :title="$t(I18N_KEY + 'confirmRecycle')" @confirm="() => recycle(record)">
                <a>{{ $t(I18N_KEY + 'recycle') }}</a>
              </a-popconfirm>
            </a-menu-item>
            <a-menu-item>
              <a-popconfirm :title="$t(I18N_KEY + 'confirmUnbind')" @confirm="() => unbindClousSeat(record)">
                <a>{{ $t(I18N_KEY + 'unbindClousSeat') }}</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <div style="margin-top: 15px; text-align: right;">
      <v-pagination v-if="total" :page-num="form.pageNum" :page-size="form.pageSize" :total="total"
        @change="handleTableChange" />
    </div>
    <user-manage-modal ref="modalForm" :seat-types='seatTypes' :user-groups='userGroups' :field-name='fieldName'
      @ok="modalFormOk"></user-manage-modal>
  </div>
</template>
<script>
import { seatList, seatOperate2, seatDelete2, unbindClousSeat, baseData, recycle } from '@/webpublicapi/teleMarket'
import UserManageModal from './modules/UserManageModal'
import { mapGetters } from "vuex"
import { filterObj } from '@/utils/util'
import moment from 'moment'
const I18N_KEY = 'teleMarket.'
export default {
  name: 'TeleMarketUserManage',
  components: {
    UserManageModal,
  },
  data() {
    return {
      I18N_KEY,
      loading: false,
      total: 0,
      seatTypes: [],
      userGroups: [],
      statuses: ["0", "1"],
      fieldName: 'textCn',
      allowClear: true,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      queryParam: {
        "type": "system",
        "userName": null,
        "mobile": null,
        "groupId": null,
        "status": null,
      },
      visible: false,
      dataSource: [],
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    // Table header
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'id'),
          dataIndex: 'id',
          width: 60,
          align: "center",
        },
        // {
        //   title: this.$t(I18N_KEY + 'seatType'),
        //   align:"center",
        //   dataIndex: 'type',
        // },
        {
          title: this.$t(I18N_KEY + 'seatMobile'),
          align: "center",
          dataIndex: 'mobile',
        },
        {
          title: this.$t(I18N_KEY + 'seat'),
          align: "center",
          dataIndex: 'seat',
        },
        {
          title: this.$t(I18N_KEY + 'userName'),
          align: "center",
          dataIndex: 'userName',
        },
        {
          title: this.$t(I18N_KEY + 'cloudCallSeat'),
          align: "center",
          dataIndex: 'callUsername',
        },
        {
          title: this.$t(I18N_KEY + 'cloudCallSeatPassword'),
          align: "center",
          dataIndex: 'callPassword',
        },
        {
          title: this.$t(I18N_KEY + 'seatStatus'),
          align: "center",
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t(I18N_KEY + 'userGroup'),
          align: "center",
          dataIndex: 'groupId',
          customRender: (text, record) => {
            for (var i in this.userGroups) {
              if (text == this.userGroups[i].value) {
                return this.userGroups[i][this.fieldName]
              }
            }
          }
        },
        {
          title: this.$t(I18N_KEY + 'createTime'),
          align: "center",
          dataIndex: 'createTime',
        },
        {
          title: this.$t(I18N_KEY + 'updateTime'),
          align: "center",
          dataIndex: 'updateTime',
        },
        {
          title: this.$t(I18N_KEY + 'operate'),
          dataIndex: 'action',
          align: "center",
          scopedSlots: { customRender: 'action' },
        }]
    },
  },
  created() {
    this.loadBaseData()
    this.loadData('')
  },
  methods: {
    loadBaseData() {
      baseData({}).then((res) => {
        if (res.code === 1000) {
          this.seatTypes = res.data.seatTypes
          this.userGroups = res.data.userGroups
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message)
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    modalFormOk(data) {
      this.createSeat(data)
    },
    handleAdd() {
      this.versionId = undefined
      this.versionId1 = undefined
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = "1"
      this.$refs.modalForm.disableSubmit = false
    },
    handleEdit(record) {
      this.versionId = record.id
      this.versionId1 = record.userId
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = "2"
      this.$refs.modalForm.disableSubmit = false
    },
    changeModal(visible) {
      this.visible = visible
    },
    deleteCurrent(row) {
      this.loading = true
      seatDelete2(row.id, row.userId).then(res => {
        this.$message.success(this.$t('success'))
        this.loadData(1)
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    unbindClousSeat(row) {
      this.loading = true
      unbindClousSeat(row.mobile).then(res => {
        this.$message.success(this.$t('success'))
        this.loadData(this.form.pageNum)
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    recycle(row) {
      this.loading = true
      var form = {
        'user': row.mobile,
        'assignStartTime': '2020-01-01',
        'assignEndTime': this.transformTime(new Date()),
      }
      recycle(form).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    createSeat(data) {
      const form = {
        ...data,
        id: this.versionId,
        userId: this.versionId1,
        opt: this.versionId ? '2' : '1',
      }
      seatOperate2(form).then(res => {
        this.$refs.modalForm.closeLoading()
        this.$refs.modalForm.close()
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData(1)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$refs.modalForm.closeLoading()
        this.$message.error(e.message)
      })
    },
    searchReset() {
      this.form = {
        pageNum: 1,
        pageSize: 30,
      }
      this.queryParam = {
        "type": "system",
        "userName": null,
        "mobile": null,
        "groupId": null,
        "status": null,
      }
    },
    getQueryParams() {
      const data = {
        ...this.queryParam,
      }
      // console.log(data)
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    loadData(pageNum) {
      if (pageNum) { this.form.pageNum = pageNum }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      seatList(Object.assign({}, params)).then(res => {
        this.loading = false
        this.total = res.data.total
        this.dataSource = res.data.rows
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    }
  },
  watch: {
    languageStorage: {
      handler(lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn'
        } else if (lang == 'es') {
          this.fieldName = 'textEs'
        } else {
          this.fieldName = 'textEn'
        }
      },
      immediate: true,
    }
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
